import React from "react";
import { useTranslation } from "react-i18next"

import { ContainerStyle } from "../components/LoadingScreen/LoadingScreenStyle"

const LoadingScreen = () => {
    const { t } = useTranslation()

    return (
        <ContainerStyle>
            {/* Loading */}
            {t('Loading')}
        </ContainerStyle>
    )
};

export default LoadingScreen;
